import { InventoryItem } from '@/root/shared-types'
import { SAIL_STATUS } from '@/root/shared-consts'

type SailDecks = Partial<Pick<InventoryItem, 'carDeck' | 'passengerDeck'>>

/** True when either deck of the sail is cancelled. */
export const isSailCancelled = ({ carDeck, passengerDeck }: SailDecks): boolean =>
  carDeck?.status === SAIL_STATUS.CANCELLED || passengerDeck?.status === SAIL_STATUS.CANCELLED

/** True when either deck of the sail is closed. */
export const isSailClosed = ({ carDeck, passengerDeck }: SailDecks): boolean =>
  carDeck?.status === SAIL_STATUS.CLOSED || passengerDeck?.status === SAIL_STATUS.CLOSED

/**
 * True when the backend marks everything the sail offers as sold out: every inventory class on both decks
 * (passengers, bicycles, cars) and every reserve inside them (e.g. the resident reserve). A sail with nothing
 * left to buy can't be picked; one category left (e.g. bicycles, sold without a passenger) keeps it open.
 */
export const isSailSoldOut = ({ carDeck, passengerDeck }: SailDecks): boolean => {
  const classes = [...(passengerDeck?.availableInventoryClasses ?? []), ...(carDeck?.availableInventoryClasses ?? [])]
  return (
    classes.length > 0 &&
    classes.every((inventoryClass) => inventoryClass.soldOut && (inventoryClass.reserves ?? []).every((r) => r.soldOut))
  )
}
